import React, { useState } from 'react';
import { toast } from 'sonner';
import { Loader2, ShieldCheck, User } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { api, extractError } from '../lib/api';
import { useAuth } from '../lib/auth';
import { fmtDateTime } from '../lib/date';

export default function ProfilePage() {
  const { user, refreshUser } = useAuth();
  const [form, setForm] = useState({ current: '', next: '', next2: '' });
  const [loading, setLoading] = useState(false);

  const change = async (e) => {
    e.preventDefault();
    if (form.next !== form.next2) { toast.error('Passwörter stimmen nicht überein.'); return; }
    setLoading(true);
    try {
      await api.post('/auth/change-password', { current_password: form.current, new_password: form.next });
      toast.success('Passwort erfolgreich geändert.');
      setForm({ current: '', next: '', next2: '' });
      await refreshUser();
    } catch (err) {
      toast.error(extractError(err));
    } finally { setLoading(false); }
  };

  return (
    <div className="p-6 max-w-3xl space-y-6">
      {user?.force_password_change && (
        <div className="rounded-md border-l-4 border-amber-500 bg-amber-50 px-4 py-3 text-sm text-amber-800">
          Bitte ändern Sie Ihr temporäres Passwort, um fortzufahren.
        </div>
      )}
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2 font-display"><User size={18}/>Profil</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="grid grid-cols-2 gap-4 text-sm">
            <div><div className="text-slate-500">Name</div><div className="font-semibold">{user?.first_name} {user?.last_name}</div></div>
            {/* Anmeldekennung statt nur E-Mail: Wer keine Adresse hat, meldet
                sich mit dem Benutzernamen an – dann soll hier auch der stehen. */}
            <div>
              <div className="text-slate-500">Anmeldung mit</div>
              <div className="font-semibold font-mono">
                {[user?.email, user?.username].filter(Boolean).join(' · ') || '–'}
              </div>
            </div>
            <div><div className="text-slate-500">Rolle</div><div className="font-semibold">
              {user?.role === 'admin' ? 'Administrator'
                : user?.role === 'projektleiter' ? 'Projektleiter' : 'Betrachter'}
            </div></div>
            <div><div className="text-slate-500">Letzter Login</div><div className="font-semibold">{user?.last_login ? fmtDateTime(user.last_login) : '–'}</div></div>
          </div>
        </CardContent>
      </Card>
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2 font-display"><ShieldCheck size={18}/>Passwort ändern</CardTitle>
        </CardHeader>
        <CardContent>
          <form onSubmit={change} className="space-y-4 max-w-md">
            <div className="space-y-1.5">
              <Label>Aktuelles Passwort</Label>
              <Input type="password" required value={form.current} onChange={e => setForm({ ...form, current: e.target.value })} data-testid="profile-current-password"/>
            </div>
            <div className="space-y-1.5">
              <Label>Neues Passwort</Label>
              <Input type="password" required value={form.next} onChange={e => setForm({ ...form, next: e.target.value })} data-testid="profile-new-password"/>
            </div>
            <div className="space-y-1.5">
              <Label>Neues Passwort wiederholen</Label>
              <Input type="password" required value={form.next2} onChange={e => setForm({ ...form, next2: e.target.value })} data-testid="profile-new-password2"/>
            </div>
            <Button type="submit" disabled={loading} data-testid="profile-submit-password">
              {loading ? <Loader2 className="mr-2 h-4 w-4 animate-spin"/> : null}
              Passwort ändern
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
